import React, { useState } from "react";
import { ExtractedArticleInformationType } from "./types/ExtractedArticleInformationType";
import DefaultScannerComponent from "./DefaultScannerComponent";

interface DefaultScannerComponentCameraControlledProps {
  onResult: (result: ExtractedArticleInformationType) => void;
  shouldHideSPRItems?: boolean;
  shouldHideLocalCombinationItems?: boolean;
}

const DefaultScannerComponentCameraControlled: React.FC<
  DefaultScannerComponentCameraControlledProps
> = ({
  onResult,
  shouldHideSPRItems = false,
  shouldHideLocalCombinationItems = false,
}) => {
  const [isCameraOpen, setIsCameraOpen] = useState(false);

  const handleCameraOpenChange = (isOpen: boolean) => {
    setIsCameraOpen(isOpen);
  };

  return (
    <DefaultScannerComponent
      onResult={onResult}
      isCameraOpen={isCameraOpen}
      onCameraOpenChange={handleCameraOpenChange}
      shouldHideSPRItems={shouldHideSPRItems}
      shouldHideLocalCombinationItems={shouldHideLocalCombinationItems}
    />
  );
};

export default DefaultScannerComponentCameraControlled;
